
import Desc_LinkAccountIcon from 'custom/assets/art-icons/LinkAccount.svg'
import Desc_Contact_UsIcon from 'custom/assets/art-icons/ContactUs.svg'
import Desc_DeLinkAccountIcon from 'custom/assets/art-icons/DelinkAccount.svg'
import Desc_DownloadIcon from 'custom/assets/details-icons/download_center.svg'
import Desc_AdditionalIcon from 'custom/assets/details-icons/additional_option.svg'
import Desc_ProfileIcon from 'custom/assets/art-icons/Profile.svg'
import Desc_SupportIcon from 'custom/assets/details-icons/support.svg'
import Desc_FAQIcon from 'custom/assets/art-icons/FAQ.svg'
import Desc_ExchangeRatesIcon from 'custom/assets/art-icons/ExchangeRate.svg'
import Desc_SuggestionsIcon from 'custom/assets/art-icons/Suggestions.svg'
import Desc_CalculatorIcon from 'custom/assets/art-icons/Calculator.svg'
import Desc_DepositIcon from 'custom/assets/art-icons/Deposit.svg'
import Desc_BranchIcon from 'custom/assets/art-icons/Locator.svg'
import Desc_LoanIcon from 'custom/assets/art-icons/Loan.svg'
import Desc_RepeatPaymentIcon from 'custom/assets/details-icons/Repeat_Payment.svg'
import Desc_MT103Icon from 'custom/assets/art-icons/MT130.svg'
import DashboardIcon from 'custom/assets/common-icons/dashboard.svg'
import { ART_WORK_KEYS } from '../../utils/translation-constants'
import Desc_Notification from "../../assets/details-icons/Notification.svg"
import Desc_DebitCardIcon from 'custom/assets/art-icons/DebitCard.svg'


export const ART_ICONS = [
    {
      desc: ART_WORK_KEYS.LINK_YOUR_ACCOUNT_DESC,
      key: 'LINK_ACCOUNT',
      descIcon: Desc_LinkAccountIcon,
    },
    {
      desc: ART_WORK_KEYS.VIEW_CONTACT_DETAILS_DESC,
      key: 'Contact_Us',
      descIcon: Desc_Contact_UsIcon,
    },
  
    {
      desc: ART_WORK_KEYS.VIEW_BANK_DESC,
      key: '/about-us',
      descIcon: Desc_Contact_UsIcon,
    },
  
    {
      desc: ART_WORK_KEYS.REMOVE_YOUR_ACCOUNT_DESC,
      key: 'DE_LINK_ACCOUNT',
      descIcon: Desc_DeLinkAccountIcon,
    },
    {
      desc: ART_WORK_KEYS.GIVE_YOUR_ACCOUNT_NAME_DESC,
      key: 'SET_ACCOUNT_NAME',
      descIcon: Desc_DeLinkAccountIcon,
    },
    {
      desc: ART_WORK_KEYS.DOWNLOAD_RECIEPT_STATEMENT_DESC,
      key: 'DOWNLOAD_CENTER',
      descIcon: Desc_DownloadIcon,
    },
    {
      desc: ART_WORK_KEYS.DOWNLOAD_RECIEPT_PAYMENT_DESC,
      key: 'PAYMENTS_DOwNLOAD_RECEIPT',
      descIcon: Desc_DownloadIcon,
    },
    {
      desc:ART_WORK_KEYS.NOTIFICATION_DESC,
      key: 'NOTIFICATION',
      descIcon: Desc_Notification,
    },
  
    {
      desc: ART_WORK_KEYS.PROFILE_SETTINGS_DESC,
      key: 'PROFILE_SETTINGS',
      descIcon: Desc_ProfileIcon,
    },
    {
      desc: ART_WORK_KEYS.CHANGE_PASSWORD_DESC,
      key: 'CHANGE_PASSWORD',
      descIcon: Desc_ProfileIcon,
    },
    {
      desc: ART_WORK_KEYS.ADDITIONAL_LINKS_DESC,
      key: 'ADDITIONAL_LINKS',
      descIcon: Desc_AdditionalIcon,
    },
    {
      desc: ART_WORK_KEYS.SUPPORT_CENTER_DESC,
      key: 'SUPPORT_CENTER',
      descIcon: Desc_SupportIcon,
    },
  
    {
      desc: ART_WORK_KEYS.LOAN_DESC,
      key: 'LOAN',
      descIcon: Desc_LoanIcon,
    },
  
    {
      desc: ART_WORK_KEYS.SI_DESC,
      key: 'SI',
      descIcon: Desc_LoanIcon,
    },
  
    {
      desc: ART_WORK_KEYS.BENE_REPEAT_DESC,
      key: 'BENE_REPEAT',
      descIcon: Desc_RepeatPaymentIcon,
    },
  
    {
      desc: ART_WORK_KEYS.RECEIPTS_DESC,
      icon: DashboardIcon,
      key: 'RECEIPTS',
      descIcon: Desc_DeLinkAccountIcon,
    },
  
    {
      desc: ART_WORK_KEYS.BI_STATEMENT_DESC,
      icon: DashboardIcon,
      key: 'BI_STATEMENT',
      descIcon: Desc_DeLinkAccountIcon,
    },
  
    {
      desc: ART_WORK_KEYS.MT103_DESC,
      icon: DashboardIcon,
      key: 'MT103',
      descIcon: Desc_MT103Icon,
    },
  
    {
      desc: ART_WORK_KEYS.SCHEDULED_PAYMENT_DESC,
      icon: DashboardIcon,
      key: 'SCHEDULED_PAYMENTS',
      descIcon: Desc_DeLinkAccountIcon,
    },

    {
      desc: ART_WORK_KEYS.SCHEDULED_TRANSFER_DESC,
      icon: DashboardIcon,
      key: 'SCHEDULED_TRANSFERS',
      descIcon: Desc_DeLinkAccountIcon,
    },
  
    {
      desc: ART_WORK_KEYS.BRANCH_DESC,
      icon: DashboardIcon,
      key: 'BRANCH',
      descIcon: Desc_BranchIcon,
    },
  
    {
      desc: ART_WORK_KEYS.DEPOSIT_DESC,
      icon: DashboardIcon,
      key: 'DEPOSIT',
      descIcon: Desc_DepositIcon,
    },
  
    {
      desc: ART_WORK_KEYS.FAQ_DESC,
      icon: DashboardIcon,
      key: 'FAQ',
      descIcon: Desc_FAQIcon,
    },
  
    {
      desc: ART_WORK_KEYS.SUGGESTIONS_DESC,
      icon: DashboardIcon,
      key: 'SUGGESTIONS',
      descIcon: Desc_SuggestionsIcon,
    },
  
    {
      desc: ART_WORK_KEYS.CALCULATOR_DESC,
      icon: DashboardIcon,
      key: 'CALCULATOR',
      descIcon: Desc_CalculatorIcon,
    },
  
    {
      desc:ART_WORK_KEYS.OFFERS_DESC,
      icon: DashboardIcon,
      key: 'OFFERS',
      descIcon: Desc_SupportIcon,
    },
  
    {
      desc:ART_WORK_KEYS.EXCHANGE_RATES_DESC,
      icon: DashboardIcon,
      key: 'EXCHANGE_RATES',
      descIcon: Desc_ExchangeRatesIcon,
    },
  
    {
      desc: ART_WORK_KEYS.SCHOOL_PAYMENT_DESC,
      icon: DashboardIcon,
      key: 'SCHOOL_PAYMENT',
      descIcon: Desc_DeLinkAccountIcon,
    },
  
    {
      desc: ART_WORK_KEYS.ADD_BILLER_DESC,
      icon: DashboardIcon,
      key: 'ADD_BILLER',
      descIcon: Desc_DeLinkAccountIcon,
    },
  
    {
      desc: ART_WORK_KEYS.VIEW_BILLER_DESC,
      icon: DashboardIcon,
      key: 'VIEW_BILLER',
      descIcon: Desc_DeLinkAccountIcon,
    },
  
    {
      desc: ART_WORK_KEYS.OTHER_PAYMENT_DESC,
      icon: DashboardIcon,
      key: 'OTHER_PAYMENT',
      descIcon: Desc_DeLinkAccountIcon,
    },
    {
      desc: ART_WORK_KEYS.ADD_ACCOUNT_DESC,
      key: 'ADD_ACCOUNT',
      descIcon: Desc_AdditionalIcon,
    },
    {
      desc: ART_WORK_KEYS.DEBIT_CARD_DESC,
      key: 'DEBIT_CARD',
      descIcon: Desc_DebitCardIcon,
    },

    {
      desc: ART_WORK_KEYS.DEBIT_CARD_DESC,
      key: 'DEBIT_CARD_REQUEST',
      descIcon: Desc_DebitCardIcon,
    },
    {
      desc: ART_WORK_KEYS.DEBIT_CARD_DESC,
      key: 'DEBIT_CARD_BLOCK',
      descIcon: Desc_DebitCardIcon,
    },
    {
      desc: ART_WORK_KEYS.DEBIT_CARD_DESC,
      key: 'DEBIT_CARD_ISSUE',
      descIcon: Desc_DebitCardIcon,
    },
  ]